// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lazy-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: var(--white-tertiaire);
    display: block;
}

.skeleton {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    min-width: 100%;
    height: 100%;
    z-index: 1;
    background: linear-gradient(90deg,
            var(--couleur-principale, #ececec) 25%,
            var(--couleur-secondaire, #f5f5f5) 50%,
            var(--couleur-principale, #ececec) 75%);
    background-size: 200% 100%;
    animation: skeleton-loader 1.5s infinite linear;
}

.lazy-image {
    display: block;
    width: 100%;
    min-width: 100%;
    height: 100%;
    object-fit: cover;
    transition: filter 0.6s ease, transform 0.6s ease, opacity 0.4s ease;
    will-change: filter, transform;
}

.lazy-image.loading {
    filter: blur(12px);
    transform: scale(1);
    opacity: 0;
}

.lazy-image.loaded {
    filter: blur(0);
    transform: scale(1);
    opacity: 1;
}

@keyframes skeleton-loader {
    from {
        background-position: 200% 0;
    }

    to {
        background-position: -200% 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/article/lazyImage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,eAAe;IACf,YAAY;IACZ,UAAU;IACV;;;mDAG+C;IAC/C,0BAA0B;IAC1B,+CAA+C;AACnD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,oEAAoE;IACpE,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;IAChC;AACJ","sourcesContent":[".lazy-wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    background-color: var(--white-tertiaire);\n    display: block;\n}\n\n.skeleton {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    min-width: 100%;\n    height: 100%;\n    z-index: 1;\n    background: linear-gradient(90deg,\n            var(--couleur-principale, #ececec) 25%,\n            var(--couleur-secondaire, #f5f5f5) 50%,\n            var(--couleur-principale, #ececec) 75%);\n    background-size: 200% 100%;\n    animation: skeleton-loader 1.5s infinite linear;\n}\n\n.lazy-image {\n    display: block;\n    width: 100%;\n    min-width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: filter 0.6s ease, transform 0.6s ease, opacity 0.4s ease;\n    will-change: filter, transform;\n}\n\n.lazy-image.loading {\n    filter: blur(12px);\n    transform: scale(1);\n    opacity: 0;\n}\n\n.lazy-image.loaded {\n    filter: blur(0);\n    transform: scale(1);\n    opacity: 1;\n}\n\n@keyframes skeleton-loader {\n    from {\n        background-position: 200% 0;\n    }\n\n    to {\n        background-position: -200% 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
